import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useHardRefresh(onRefresh: () => void) {
  const location = useLocation(); // 👈 must call this inside the hook

  useEffect(() => {
    const currentPath = location.pathname;
    const refreshKey = `hardRefresh_${currentPath}`;
    const wasRefreshed = sessionStorage.getItem(refreshKey) === "true";

    if (wasRefreshed) {
      sessionStorage.removeItem(refreshKey);
      onRefresh(); // callback runs here
    }

    const handleBeforeUnload = () => {
      sessionStorage.setItem(refreshKey, "true");
    };
    
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname, onRefresh]); // 👈 must include pathname in deps
}
